import React from 'react';

import PropTypes from 'prop-types';

const AuthLayout = ({ children }) => (
  <div className="auth-wrapper auth-v1 px-2">
    <div className="auth-inner py-2">{children}</div>
  </div>
);

AuthLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AuthLayout;
